<template>
    <v-form ref="addNewAnalysis" v-model="valid">
        <v-row>
            <v-col cols="12">
                <v-textarea v-model="files.description" label="Description"></v-textarea>
            </v-col>
            <v-col cols="12" class="text-center">
                <UploadButton ref="fileUpload" :allowedFileExtensions="allowedFileExtensions" @fileSelected="fileSelected" @fileInvalid="fileInvalid" :maxFileSizeMB="2" />
            </v-col>
            <v-col cols="12" class="text-center" v-if="fileError">
                <v-alert text type="error">{{fileError}}</v-alert>
            </v-col>
            <v-col cols="12">
                <v-textarea v-model="files.OtherComments" label="Other Comments"></v-textarea>
            </v-col>
            <v-col cols="12" class="text-center">
                <v-btn color="success" @click="addFile" :disabled="!validComplete || saving" :loading="saving">Add File</v-btn>
            </v-col>
            <v-col cols="12" class="text-center" v-if="saveError">
                <v-alert text type="error">{{saveError}}</v-alert>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import * as venomAnalysisAPI from '@/services/venomAnalysisAPI';
import UploadButton from '@/components/common/UploadButton.vue';
import fileService from '../../services/fileService';

export default {
    components: {
        UploadButton
    },
    props: {   
        monthlyPoolID: {
            type: Number,
            default: -1
        },
    },
    data() {
        return {
            proteins: [],
            loadingError: "",
            files: {
            },
            valid: false,
            allowedFileExtensions: '.pdf, .docx, .doc',
            fileError: "",
            pendingFile: null,
            saveError: "",
            saving: false
        };
    },
    computed: {
        validComplete() {
            return this.files.description && this.pendingFile != null;
        }
    },
    methods:{
        createBlankAnalysis() {
            this.files = {
                description:"",
                OtherComments: "",
            };

            this.pendingFile = null;

            if (this.$refs.fileUpload) {
                this.$refs.fileUpload.reset();
            }
        },
        async addFile() {
            this.saving = true;
            this.saveError = "";

            try {
                // Add the file
                if (this.pendingFile != null) {
                    var document = {
                        MonthlyPoolID: this.monthlyPoolID,
                        FileName: this.pendingFile.FileName,
                        description:this.files.description,
                        comments:this.files.OtherComments
                    };

                    await fileService.uploadFileAndSaveDocument(document, this.pendingFile.FileName, "monthlyPool", this.pendingFile.ContentType, this.pendingFile.FileData)
                }

                this.$emit("created");

                // Clear everything
                this.createBlankAnalysis();
            } catch (e) {
                this.saveError = e.message;
            }
            
            this.saving = false;
        },
        fileSelected(file) {
            this.fileError = '';
            this.pendingFile = file;
        },
        fileInvalid(errorMessage) {
            this.fileError = errorMessage;
            this.pendingFile = null;
        },
    },
    async created() {

        this.createBlankAnalysis();

    }
}
</script>

<style scoped>
    td.width-25percent {
        width: 25%;
    }
    td.width-15percent {
        width: 15%;
    }
    td.width-5percent {
        width: 5%;
    }
</style>